<template>
  <section v-if="Object.keys(pricing).length" id="pricing-plan">
    <!-- title text and switch button -->
    <div class="text-center">
      <h1>
        {{ $t("pricing.title") }}
      </h1>
      <p class="mb-1 pb-75">
        {{ $t("pricing.description") }}
        <!-- All plans include 40+ advanced tools and features to boost your product. Choose the best plan to fit your needs. -->
      </p>
      <div class="d-flex align-items-center justify-content-center mb-1 pb-50">
        <h6 class="mr-1 mb-0">
          {{ $t("pricing.monthly") }}
        </h6>
        <b-form-checkbox
          id="priceSwitch"
          v-model="status"
          name="price-switch"
          value="annually"
          unchecked-value="monthly"
          switch
          @input="tooglePlan"
        />
        <h6 class="ml-50 mb-0">
          {{ $t("pricing.annually") }}
        </h6>
      </div>
    </div>
    <!--/ title text and switch button -->

    <div
      v-if="monthlyplans.length === 0 || yearlyPlans.length === 0"
      style="height: 100vh"
    >
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>

    <!-- pricing plan cards -->
    <b-row
      v-if="monthlyplans.length && yearlyPlans.length"
      class="pricing-card"
    >
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto d-flex align-items-center justify-content-center"
      >
        <b-col cols="10">
          <b-row
            class="mx-auto d-flex align-items-center justify-content-center"
          >
            <!-- Basic Plan -->
            <b-col
              v-for="(item, index) in monthlyPlanShow
                ? monthlyplans
                : yearlyPlans"
              :key="index"
              md="4"
            >
              <b-card align="center" class="pb-1">
                <!-- img -->
                <b-img
                  v-if="hotAirBallon"
                  :src="getImageForItem(index)"
                  class="mb-2 mt-1 w-25"
                  alt="basic svg img"
                />
                <!--/ img -->
                <h3>{{ item.name }}</h3>
                <b-card-text>
                  {{ $t("pricing.simple_start_for_everyone") }}
                </b-card-text>

                <!-- Plan fee -->
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <sup class="font-medium-1 font-weight-bold text-primary"
                      >$</sup
                    >
                    <span
                      class="pricing-basic-value font-weight-bolder text-primary"
                    >
                      {{ monthlyPlanShow ? item.monthPrice : item.fee }}
                    </span>
                    <sub
                      class="pricing-duration text-body font-medium-1 font-weight-bold"
                      >/{{ $t("pricing.month") }}</sub
                    >
                  </div>
                  <small
                    v-show="!monthlyPlanShow"
                    class="annual-pricing text-muted"
                    >$ {{ item.yearPrice }} / {{ $t("pricing.year") }}</small
                  >
                </div>

                <b-list-group class="list-group-circle text-left">
                  <b-list-group-item>
                    <div>
                      {{
                        monthlyPlanShow
                          ? item.trackingLimit
                          : item.trackingLimit
                      }}
                      tracking per {{ item.isBank ? "month" : "day" }}
                    </div>
                  </b-list-group-item>
                </b-list-group>

                <!-- buttons -->
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  block
                  class="mt-2"
                  :variant="item.isSubscription ? 'outline-success' : 'primary'"
                  @click="handlePlanUpgrade(item)"
                >
                  {{
                    item.isSubscription
                      ? $t("pricing.plan")
                      : $t("pricing.upgrade")
                  }}
                </b-button>
              </b-card>
            </b-col>

            <!-- Platinum Plan -->
            <b-col md="4">
              <b-card align="center" class="pb-1">
                <!-- img -->
                <b-img
                  v-if="roketImage"
                  :src="roketImage"
                  class="mb-2 w-25"
                  alt="enterprise svg img"
                />
                <!--/ img -->
                <h3>Platinum</h3>
                <b-card-text>{{ $t("pricing.big_organisations") }}</b-card-text>

                <!-- annual plan -->
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <sup class="font-medium-1 font-weight-bold text-primary"
                      >$Custom</sup
                    >
                    <span
                      class="pricing-basic-value font-weight-bolder text-primary"
                    >
                      <!-- {{
                      monthlyPlanShow ? pricing.platinumPlan.monthlyPrice : pricing.platinumPlan.yearlyPlan.perMonth
                    }} -->
                    </span>
                    <sub
                      class="pricing-duration text-body font-medium-1 font-weight-bold"
                    />
                  </div>
                  <small
                    v-show="!monthlyPlanShow"
                    class="annual-pricing text-muted"
                  />
                </div>
                <!--/ annual plan -->

                <b-list-group class="list-group-circle text-left">
                  <b-list-group-item>
                    <div>
                      contact us for more details
                      <!-- {{ monthlyPlanShow ? tlPlantinumMonthly : tlPlantinumAnnualy }} tracking per day -->
                    </div>
                  </b-list-group-item>
                </b-list-group>

                <!-- buttons -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  block
                  class="mt-2"
                  variant="outline-primary"
                >
                  {{ $t("pricing.upgrade") }}
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
    <!--/ pricing plan cards -->

    <b-row>
      <b-col><b>Забележка: </b>Всички цени са без ДДС</b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BFormCheckbox,
  BRow,
  BCol,
  BCard,
  BImg,
  BCardText,
  BListGroup,
  BListGroupItem,
  BButton,
  BBadge,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Ripple from "vue-ripple-directive";
import useJwt from "@/auth/jwt/useJwt";
import axios from "@/libs/axios";
/* eslint-disable global-require */
export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      annualPlatinumMonth: "",
      annualPlatinum: "",
      monthlyPlatinum: "",

      status: "monthly",
      monthlyPlanShow: true,
      plansPrice: [],
      monthlyplans: [],
      yearlyPlans: [],
      pricing: {
        platinumPlan: {
          title: "Platinum",
          img: require("@/assets/images/illustration/Pot3.svg"),
          subtitle: "Solution for big organizations",
          monthlyPrice: 129,
          yearlyPlan: {
            perMonth: 149,
            totalAnual: 149 * 12,
          },
          trackingLimit: null,
          planBenefits: [
            "companiess",
            "unlimited_ocr_invoices",
            "unlimited_space",
            "unlimited_digital_invoices",
            "click_monthly_vat_report",
          ],
          popular: false,
          companyLimit: null, // Will be updated from the server
          documentLimit: null, // Will be updated from the server
        },
      },
    };
  },
  created() {
    this.hotAirBallon = require("@/assets/images/illustration/hot-air-balloon.svg");
    this.aeroplanImage = require("@/assets/images/illustration/aeroplane-transport-svgrepo-com.svg");
    this.roketImage = require("@/assets/images/illustration/rocket-svgrepo-com.svg");
    this.aeroplanJetImage = require("@/assets/images/illustration/aeroplane-plane-svgrepo-com.svg");
    this.helicolptorImage = require("@/assets/images/illustration/helicoptor.svg");
    this.monthlyPlanShow = this.status === "monthly";
    this.getPlansValues();
  },
  mounted() {
    if (this.$route.query.planId && this.$route.query.session_id) {
      const paymentData = {
        planId: this.$route.query.planId,
        sessionId: this.$route.query.session_id,
      };
      axios
        .post("account/api/payment/complete-payment", paymentData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // assuming accessToken is correct
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.SUCCESS == "OK") {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Payment has been paid successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.$router.push({ name: "my-plans" });
          }
        });
    }
  },
  methods: {
    tooglePlan() {
      this.monthlyPlanShow = this.status === "monthly";
    },

    // get plans
    getPlansValues() {
      useJwt
        .getPlansPrices()
        .then((response) => {
          this.plansPrice = response.data;
          let filteredPlans = response.data.filter(
            (plan) => plan.name !== "PLATINIUM"
          );
          this.monthlyplans = filteredPlans.filter(
            (item) => item.planType === "MONTHLY"
          );
          this.yearlyPlans = filteredPlans.filter(
            (item) => item.planType === "YEARLY"
          );
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching prices",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    handlePlanUpgrade(item) {
      let currentPlan = { ...item };
      currentPlan.isSubscription = true;
      axios
        .post("account/api/payment/create-payment", currentPlan, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // assuming accessToken is correct
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          const successURL = res.data.redirectUrl;
          window.open(successURL, "_blank");
        });
    },
    getImageForItem(index) {
      const images = [
        this.hotAirBallon,
        this.aeroplanImage,
        this.roketImage,
        this.aeroplanJetImage,
        this.helicolptorImage,
      ];
      return images[index % images.length];
    },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
